// GG-UPSELL (Abe 10/28): "Goes Great With" loader + one-click AJAX add (Horizon cart events)
import { CartLinesUpdateEvent } from '@shopify/events';

const MAX = 4;

class GGUpsell extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-gg-add]');
      if (btn && this.contains(btn)) { e.preventDefault(); this.add(btn); }
    });
    if (this.hasAttribute('data-cart-row')) return;
    if (this.closest('dialog, .quick-add-modal')) { this.hidden = true; return; }
    this.grid = this.querySelector('[data-gg-grid]');
    if (this.count() < 3) this.fill();
    else this.finish();
  }

  count() { return this.grid ? this.grid.querySelectorAll('.gg-card').length : 0; }

  shownIds() {
    const ids = new Set([String(this.dataset.productId)]);
    this.grid.querySelectorAll('[data-gg-product]').forEach((c) => ids.add(c.dataset.ggProduct));
    return ids;
  }

  absorb(container) {
    if (!container) return;
    const ids = this.shownIds();
    container.querySelectorAll('.gg-card').forEach((card) => {
      if (this.count() >= MAX) return;
      const id = card.dataset.ggProduct;
      if (!id || ids.has(id)) return;
      ids.add(id);
      this.grid.appendChild(card);
    });
  }

  async fetchIntent(intent) {
    try {
      const base = this.dataset.recsUrl || '/recommendations/products';
      const url = `${base}?section_id=gg-upsell-recs&product_id=${this.dataset.productId}&limit=8&intent=${intent}`;
      const res = await fetch(url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      this.absorb(doc.querySelector('[data-gg-recs]'));
    } catch (e) { /* ignore */ }
  }

  async fill() {
    await this.fetchIntent('complementary');
    if (this.count() < 3) await this.fetchIntent('related');
    if (this.count() < 3) {
      const tpl = this.querySelector('template[data-gg-fallback]');
      if (tpl) this.absorb(tpl.content);
    }
    this.finish();
  }

  finish() {
    const n = this.count();
    if (this.grid) this.grid.dataset.n = String(n);
    this.hidden = n === 0;
  }

  async add(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    const label = btn.querySelector('.gg-card__add-label') || btn;
    const original = label.textContent;

    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el.dataset.sectionId && !sectionIds.includes(el.dataset.sectionId)) sectionIds.push(el.dataset.sectionId);
    });

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    }));

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'gg-upsell',
          sourceId: 'gg-upsell',
          itemCount: 1,
          productId: btn.closest('[data-gg-product]')?.dataset.ggProduct,
          sections: data.sections,
          didError: false,
        },
      });
      label.textContent = 'Added ✓';
      btn.classList.add('is-added');
      setTimeout(() => { label.textContent = original; btn.classList.remove('is-added'); }, 2500);
    } catch (err) {
      try {
        const cart = await (await fetch('/cart.js')).json();
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'gg-upsell', sourceId: 'gg-upsell', itemCount: 0, didError: true } });
      } catch (e) { deferred.reject && deferred.reject(err); }
      label.textContent = 'Unavailable';
      setTimeout(() => { label.textContent = original; }, 2500);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('gg-upsell')) customElements.define('gg-upsell', GGUpsell);
